/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from 'components/Button';
import Heading from 'components/Heading';
import PropTypes from 'prop-types';

import goToPreviousStep from '../../hooks/registration/goToPreviousStep';

import styles from './ProgressBar.module.scss';

const ProgressBar = ({ step, totalSteps, title }) => {
  const history = useHistory();
  const stepNumber = parseInt(step, 10);
  const totalStepsNumber = parseInt(totalSteps, 10);
  const progressAsPercentage =
    totalStepsNumber > 0 ? (stepNumber / totalStepsNumber) * 100 : 0;
  const previousStep = goToPreviousStep(step);

  const backClick = () => {
    previousStep();
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.bar}
        role="progressbar"
        aria-valuenow={step}
        aria-valuemin="0"
        aria-valuetext={title}
        aria-valuemax={totalSteps}
      >
        <div className={styles.back}>
          <Button
            appearance="icon-only"
            iconName="ArrowLeft"
            text="Back"
            onClick={backClick}
            width="42px"
            height="42px"
          />
        </div>
        <Heading appearance="h5" priority="1" className={styles.heading}>
          <span className={styles['current-step']}>{step}</span>
          {` of ${totalSteps} - ${title}`}
        </Heading>
      </div>
      <svg width="100%" height="8px" className={styles.line}>
        <line
          x1="0"
          x2="100%"
          y1="0"
          y2="0"
          stroke="var(--neutral-5)"
          strokeWidth={10}
        />
        <line
          x1="0"
          x2={`${progressAsPercentage}%`}
          y1="0"
          y2="0"
          stroke="var(--secondary-1)"
          strokeWidth={10}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

ProgressBar.propTypes = {
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  totalSteps: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  title: PropTypes.string.isRequired
};

export default ProgressBar;
